import { FC, useState } from "react";
import { Button, message } from "antd";
import axiosInstance from "../axiosInstance";
import { getCollectionFields } from "../services/collectionFields";
import { transformToApiQueryParams } from "../hooks/useQueryParamsToState";


interface DownloadProps {
  filters: Record<string, string[]>;
  collectionId: string;
  endpoint: string;
  filename: string;
  label?: string;
}

const Download: FC<DownloadProps> = ({
  filters,
  collectionId,
  endpoint,
  filename,
  label = "Exporter cette recherche (max 10000)",
}) => {
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const handleFetchData = async () => {
    setLoading(true);
    try {
      const fields = await getCollectionFields(collectionId);
      const apiParams = transformToApiQueryParams(
        fields,
        new URL(window.location.href).searchParams
      );

      const response = await axiosInstance.post(
        endpoint,
        { filters: JSON.parse(apiParams.get("filter")!) },
        { responseType: "blob" }
      );

      const data = response.data;
      const isEmptyString = typeof data === "string" && data === "";
      const isEmptyBlob = data instanceof Blob && data.size === 0;

      if (isEmptyString || isEmptyBlob) {
        messageApi.open({
          type: "error",
          content: "Une erreur est survenue lors du téléchargement. Avez-vous accès ?",
        });
        return;
      }

      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {contextHolder}
      {/* Fetch Stats Button */}
      <Button
        style={{ backgroundColor: "#3eafff" }}
        onClick={handleFetchData}
        loading={loading}
      >
        {label}
      </Button>

    </>
  );
};

export default Download;
